import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { compose, lifecycle } from 'recompose';

import connect from 'app/libs/connect';
import { isMultiTier } from 'app/features/products/selectors';
import Products from 'app/features/landing/productComparison/components/Products';
import AlternativeLink from 'app/features/landing/productComparison/components/AlternativeLink/AlternativeLink';
import S from 'app/features/landing/productComparison/components/ProductComparison.styled';
import Text from 'app/components/layout/Text.styled';
import {
  PRODUCT_COMPARISON_ANCHOR,
  PRODUCT_COMPARISON_ANCHOR_PLANS,
} from 'app/features/landing/productComparison/constants';
import Heading from 'app/components/layout/Heading.styled';
import {
  titleKey,
  subtitleKey,
  mangaAndStoreAvailabilityKey,
  videoAvailabilityKey,
} from 'app/features/landing/productComparison/selectors';
import { getLocationHash } from 'app/router/selectors';

function componentDidMount() {
  const { locationHash } = this.props;

  if (
    locationHash === PRODUCT_COMPARISON_ANCHOR ||
    locationHash === PRODUCT_COMPARISON_ANCHOR_PLANS
  ) {
    window.setTimeout(
      () =>
        document.getElementById(PRODUCT_COMPARISON_ANCHOR).scrollIntoView({
          behavior: 'smooth',
        }),
      1000,
    );
  }
}

const UI = ({
  titleKey,
  subtitleKey,
  mangaAndStoreAvailabilityKey,
  videoAvailabilityKey,
  isMultiTier,
}) => (
  <S.ProductComparison
    data-t="product-comparison-block"
    id={PRODUCT_COMPARISON_ANCHOR}
  >
    <Heading size="l" as={S.ProductComparison.Title}>
      <FormattedMessage id={titleKey} />
    </Heading>
    <Text size="xl" as={S.ProductComparison.SubTitle}>
      <FormattedMessage id={subtitleKey} />
    </Text>
    <S.ProductComparison.ProductsHolder isMultiTier={isMultiTier}>
      <Products />
    </S.ProductComparison.ProductsHolder>
    <Text as={S.ProductComparison.Availability} size="m" type="semibold">
      <FormattedMessage id={mangaAndStoreAvailabilityKey} />
      <br />
      <FormattedMessage id={videoAvailabilityKey} />
    </Text>
    <AlternativeLink />
  </S.ProductComparison>
);

UI.propTypes = {
  titleKey: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string.isRequired,
  mangaAndStoreAvailabilityKey: PropTypes.string.isRequired,
  videoAvailabilityKey: PropTypes.string.isRequired,
  isMultiTier: PropTypes.bool.isRequired,
};

UI.displayName = 'ProductComparison';

const state = {
  titleKey,
  subtitleKey,
  mangaAndStoreAvailabilityKey,
  videoAvailabilityKey,
  locationHash: getLocationHash,
  isMultiTier,
};

const ProductComparison = compose(
  connect(state),
  lifecycle({ componentDidMount }),
)(UI);

export { UI, componentDidMount };

export default ProductComparison;
